<template>
  <div class="preview-box creative-preview">
    <template v-if="creativeForm.dynamic_creative_name">
      <Divider title="创意形式"></Divider>
      <LabelRow label="创意名称：">{{ creativeForm.dynamic_creative_name }}</LabelRow>
      <LabelRow label="投放模式：">{{ DELIVERY_MODE_LIST.find((mode) => mode.value === creativeForm.delivery_mode).label }}</LabelRow>
      <LabelRow label="创意匹配模式：">
        {{ DYNAMIC_CREATIVE_TYPE_LIST.find((type) => type.value === creativeForm.dynamic_creative_type).label }}
      </LabelRow>
      <LabelRow v-if="isManualCreative" label="创意形式：">{{ creativeTemplateName }}</LabelRow>

      <Divider title="营销组件"></Divider>
      <template v-if="!isWxGamePlayable">
        <LabelRow label="朋友圈文字链：" v-if="creativeComponents.text_link.switch">
          <p>文字链文案：{{ linkNameTypeText }}</p>
          <p v-if="platform.isMiniGame">跳转落地页：微信小游戏</p>
          <p v-else>
            <span>跳转落地页：</span>
            <span v-if="creativeComponents.mini_card_link.page_type === PAGE_TYPES.OFFICIAL">官方落地页</span>
            <span v-if="creativeComponents.mini_card_link.page_type === PAGE_TYPES.IOS_APP">App Store下载页</span>
          </p>
        </LabelRow>
      </template>

      <template v-if="!isManualCreative">
        <LabelRow label="图文链接：" v-if="creativeComponents.mini_card_link && creativeComponents.mini_card_link.switch">
          <p v-if="creativeComponents.mini_card_link.mini_card_link_image.url">
            <span>创意图片：</span>
            <el-image style="width: 90px" :src="creativeComponents.mini_card_link.mini_card_link_image.url"></el-image>
          </p>
          <p>文字链文案：{{ creativeComponents.mini_card_link.mini_card_link_description }}</p>
          <p>按钮文案：{{ creativeComponents.mini_card_link.mini_card_link_button_text }}</p>
          <p v-if="platform.isMiniGame">跳转落地页：微信小游戏</p>
          <p v-else>
            <span>跳转落地页：</span>
            <span v-if="creativeComponents.mini_card_link.page_type === PAGE_TYPES.OFFICIAL">官方落地页</span>
            <span v-if="creativeComponents.mini_card_link.page_type === PAGE_TYPES.IOS_APP">App Store下载页</span>
          </p>
        </LabelRow>

        <LabelRow label="小游戏试玩：" v-if="creativeComponents.wxgame_playable_component">
          <el-switch :value="creativeComponents.wxgame_playable_component.switch"></el-switch>
          <template v-if="creativeComponents.wxgame_playable_component.switch">
            <p>开启方式：{{ wxgamePlayableTriggerNames }}</p>
            <p>图片： <el-image style="width: 90px" :src="creativeComponents.wxgame_playable_component.card_link_image.url"></el-image></p>
            <p>文案：{{ creativeComponents.wxgame_playable_component.wxgame_playable_page_card_link_description }}</p>
            <p>按钮文案：{{ creativeComponents.wxgame_playable_component.wxgame_playable_page_trigger_text }}</p>
            <el-tooltip
              effect="dark"
              :content="creativeComponents.wxgame_playable_component.wxgame_playable_page_path"
              placement="top-start"
            >
              <p>试玩页：{{ creativeComponents.wxgame_playable_component.wxgame_playable_page_path }}</p>
            </el-tooltip>
            <p>结束页： <el-image style="width: 90px" :src="creativeComponents.wxgame_playable_component.end_cover_img.url"></el-image></p>
            <p>结束页文案：{{ creativeComponents.wxgame_playable_component.wxgame_playable_page_end_desc }}</p>
            <p>结束时间：{{ wxgamePlayableEndTimeText }}</p>
          </template>
        </LabelRow>

        <LabelRow label="行动按钮：">
          <el-switch disabled :value="creativeComponents.action_button.switch"></el-switch>
          <p>{{ creativeComponents.action_button.value }}</p>
        </LabelRow>
        <LabelRow label="礼包组件：" v-if="creativeComponents.app_gift_pack_code.switch">
          <p>礼包描述：{{ creativeComponents.app_gift_pack_code.description }}</p>
          <p>礼包码：{{ creativeComponents.app_gift_pack_code.code }}</p>
        </LabelRow>
        <LabelRow label="标签：" v-if="creativeComponents.label.length">
          {{ creativeComponents.label.map((l) => l.name).join('、') }}
        </LabelRow>
        <LabelRow label="浮层卡片：">
          <el-switch :value="creativeComponents.floating_zone.floating_zone_switch"></el-switch>
          <template v-if="creativeComponents.floating_zone.floating_zone_switch">
            <p>创意图片： <el-image style="width: 90px" :src="creativeComponents.floating_zone.floating_zone_image.url"></el-image></p>
            <p>文案：{{ creativeComponents.floating_zone.floating_zone_name }}</p>
            <p v-if="creativeComponents.floating_zone.floating_zone_desc">
              文案二：{{ creativeComponents.floating_zone.floating_zone_desc }}
            </p>
            <p v-if="creativeComponents.floating_zone.floating_zone_button_text">
              按钮文案：{{ creativeComponents.floating_zone.floating_zone_button_text }}
            </p>
          </template>
        </LabelRow>
        <LabelRow label="弹幕：" v-if="creativeComponents.barrage.length">
          {{ creativeComponents.barrage.map((b) => b.text).join('、') }}
        </LabelRow>
      </template>

      <LabelRow label="数据外显：">
        <el-switch :value="creativeComponents.show_data.switch"> </el-switch>

        <template v-if="creativeComponents.show_data.switch">
          <p>
            数据类型：{{ CONVERSION_DATA_TYPE_LIST.find((item) => item.value === creativeComponents.show_data.conversion_data_type).label }}
          </p>
          <p v-if="creativeComponents.show_data.conversion_data_type === CONVERSION_DATA.ADMETRIC">
            转化行为：{{ showDataConversionTargetText }}
          </p>
        </template>
      </LabelRow>
      <template v-if="creativeForm.components.wxgame_playable_material_config">
        <LabelRow v-if="isWxGamePlayable" label="试玩素材：">
          <p>账号：{{ creativeForm.components.wxgame_playable_material_config.account.adAccount }}</p>

          <p>试玩页 ：{{ creativeForm.components.wxgame_playable_material_config.playable_item.playable_page_name }}</p>
          <p>结束时间：{{ wxgamePlayableEndTimeText }}</p>
        </LabelRow>
      </template>
      <template v-if="!isWxGamePlayable">
        <LabelRow label="首评回复：" v-if="socialSkill.show">
          {{ socialSkill.comment }}
        </LabelRow>
      </template>
      <template v-if="!isManualCreative">
        <LabelRow label="视频结束页：">
          <el-switch :value="creativeComponents.end_page.switch"> </el-switch>

          <template v-if="creativeComponents.end_page.switch">
            <p>视频结束页类型：{{ END_PAGE_TYPE_LIST.find((item) => item.value === creativeComponents.end_page.end_page_type).label }}</p>
            <p>结束页文案：{{ creativeComponents.end_page.end_page_desc }}</p>
          </template>
        </LabelRow>
        <LabelRow label="是否保存视频号：">
          <el-switch :value="creativeComponents.wechat_channels.finder_object_visibility"></el-switch>
        </LabelRow>
      </template>
    </template>
  </div>
</template>

<script setup>
import { inject, computed } from 'vue'
import Divider from '@/views/create/bytedance/components/layout/title-divider.vue'
import LabelRow from '@/views/create/bytedance/components/layout/label-row.vue'

import {
  DELIVERY_MODE_LIST,
  LINK_NAME_TYPE,
  LINK_NAME_TYPE_MINIGAME,
  DYNAMIC_CREATIVE_TYPE_LIST,
  CREATIVE_TEMPLATE_LIST,
  BRAND_ENUM,
  CONVERSION_DATA,
  CONVERSION_DATA_TYPE_LIST,
  MINIGAME_CONVERSION_TARGET_LIST,
  APP_CONVERSION_TARGET_LIST,
  END_PAGE_TYPE_LIST,
  PAGE_TYPES,
  WXGAME_PLAYABLE_PAGE_END_TIME,
  WXGAME_PLAYABLE_PAGE_TRIGGER_TYPES
} from '@/views/create/gdt/model/creative-const.js'

import { useGdtCreativeComputes } from '@/views/create/gdt/template/hooks/utils/creative.js'
import { useGdtTemplateUtils } from '@/views/create/gdt/template/hooks/utils/index.js'

// eslint-disable-next-line
const props = defineProps({
  form: Object
})
const { configForm } = inject('configForm')
const creativeForm = computed(() => configForm.value.creativeForm)
const creativeComponents = computed(() => creativeForm.value.components)
const planForm = computed(() => configForm.value.planForm)
const { platform } = useGdtTemplateUtils(planForm)
const { isManualCreative, isWxGamePlayable } = useGdtCreativeComputes(creativeForm, planForm)

const creativeTemplateName = computed(() => {
  return CREATIVE_TEMPLATE_LIST.find((item) => item.id === creativeForm.value.creative_template_id)?.label || '-'
})

const socialSkill = computed(() => {
  const { social_skill_first_comment: comment, social_skill_first_comment_switch } = creativeForm.value.components?.social_skill || {}
  return {
    show: social_skill_first_comment_switch,
    comment
  }
})

const wxgamePlayableTriggerNames = computed(() => {
  const { wxgame_playable_component } = creativeComponents.value
  if (!wxgame_playable_component) return ''
  return WXGAME_PLAYABLE_PAGE_TRIGGER_TYPES.filter((item) =>
    wxgame_playable_component.wxgame_playable_page_trigger_types.includes(item.value)
  )
    .map((i) => i.label)
    .join('、')
})

const wxgamePlayableEndTimeText = computed(() => {
  const playablePage = isWxGamePlayable.value
    ? creativeComponents.value.wxgame_playable_material_config
    : creativeComponents.value.wxgame_playable_component
  const { wxgame_playable_page_end_time_type } = playablePage || {}
  const endTimeTextMap = {
    [WXGAME_PLAYABLE_PAGE_END_TIME.THIRTY_SECONDS]: '30s（推荐）',
    [WXGAME_PLAYABLE_PAGE_END_TIME.COMPLETE]: '自定义'
  }
  return endTimeTextMap[wxgame_playable_page_end_time_type] || '-'
})

const linkNameTypes = computed(() => {
  return platform.value.isMiniGame ? LINK_NAME_TYPE_MINIGAME : LINK_NAME_TYPE
})

const linkNameTypeText = computed(() => {
  const linkName = linkNameTypes.value.find((name) => name.value === creativeForm.value.components.text_link.value)
  return linkName?.label || ''
})

const showDataConversionTargetText = computed(() => {
  const { conversion_target_type } = creativeForm.value.components.show_data
  if (platform.value.isMiniGame) {
    return MINIGAME_CONVERSION_TARGET_LIST.find((item) => item.value === conversion_target_type)?.label
  }
  return APP_CONVERSION_TARGET_LIST.find((item) => item.value === conversion_target_type)?.label
})
</script>

<style lang="scss" scoped>
.preview-box {
  height: 720px;
  overflow: auto;
  padding: 10px;
}
.creative-preview {
  p,
  .el-switch {
    margin-bottom: 5px;
  }
}
</style>
